import React from 'react';
import ReactLoading from "react-loading";
import '../Asset/Css/main.css';

function Spinner() {
    return (
        <ReactLoading type={"bars"} color="#3e3286" className="loader-new" />
    );
}

export default Spinner;